import ModelBuilder from 'helpers/ModelBuilder';
import { EntityBase, EntityLike } from './EntityBase';
import { QuoteRequest, QuoteResponse, TaxDetailInfo } from 'services/interfaces/QuotePayload';
import { RateTypeSummary } from 'interfaces/RateDetails';
import { Reservation } from './Reservation';

export class Quote extends EntityBase {
  id: string;
  rateId: string;
  label: string;
  rateDetailSummary: RateTypeSummary;
  nights: number;
  availableSites: number;
  subtotal: number;
  tax: number;
  taxDetails: TaxDetailInfo[];
  total: number;
  transactionFee: number;
  deposit: number;
  discount: number;
  createdAt: string;

  static Model: typeof ModelDefinition;

  static new(object: EntityLike<Quote>) {
    return super.fill(this, object);
  }
}

const mapModel = ModelBuilder.buildMapModel<Quote, QuoteResponse>(payload => {
  const { rateDetail } = payload;

  const model = Quote.new({
    ...payload,
    nights: payload.numberOfNights,
    availableSites: payload.numberOfAvailableSites,
    rateDetailSummary: {
      daily: rateDetail.daily?.summary,
      monthly: rateDetail.monthly?.summary,
    },
    taxDetails: payload.taxDetail,
  });

  return model;
});

const buildPayload = (reservation: Reservation) => {
  const [arrival, departure] = reservation.dateRange;
  const payload = QuoteRequest.new({...reservation, ...reservation.visitorsInfo});
  payload.arrivalDate = arrival.format('YYYY-MM-DD');
  payload.departureDate = departure.format('YYYY-MM-DD');
  payload.rateType = 'daily';
  // payload.monthlyRateStrategy = reservation.rateStrategy;

  return payload;
}

class ModelDefinition {
  static mapModel = mapModel;
  static buildPayload = buildPayload;
}
Quote.Model = ModelDefinition;
